"use client";

import React, { useState } from "react";
import Link from "next/link";
import { Drawer, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import StorefrontIcon from "@mui/icons-material/Storefront";
import QuoteRequestPopup from "../Shared/QuoteRequest/QuoteRequestPopup";
import MobileShopDrawer from "../Shared/MegaMenu/MobileShopDrawer";
import "./MobileNavLinks.scss";
// import PaymentsButton from "../PaymentsButton/PaymentsButton";

interface MobileNavLinksProps {
  monthlyFlyerUrl: string;
}

type NavLinkItem = {
  label: string;
  href: string;
  useQuotePopup?: boolean;
  usePaymentsPopup?: boolean;
  isExternal?: boolean;
};

const MobileNavLinks: React.FC<MobileNavLinksProps> = ({ monthlyFlyerUrl }) => {
  const isMobile = useMediaQuery("(max-width:1024px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [shopDrawerOpen, setShopDrawerOpen] = useState(false);
  const navLinks: NavLinkItem[] = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
    // { label: "Payments", href: "#payments", usePaymentsPopup: true },
    { label: "Our Services", href: "/services" },
    { label: "Chick Orders", href: "/chickens" },
    { label: "Flexiti Financing", href: "/flexiti-financing" },
    { label: "Account Application", href: "/account-applications" },
    { label: "Magazine Subscription", href: "/magazine-subscription" },
    { label: "Referral Form", href: "/Referral" },
    { label: "Careers", href: "/careers" },
    { label: "Building Packages", href: "/building-packages" },
    { label: "Request a Quote", href: "/quote-request", useQuotePopup: true },
  ];

  if (monthlyFlyerUrl) {
    navLinks.splice(4, 0, {
      label: "Monthly Flyer",
      href: monthlyFlyerUrl,
      isExternal: true,
    });
  }

  if (!isMobile) return null;

  return (
    <>
      <div className="mobile-nav-links-bar">
        <button
          type="button"
          aria-label="Open shop menu"
          onClick={() => {
            setDrawerOpen(false);
            setShopDrawerOpen(true);
          }}
          className="mobile-nav-links-trigger mobile-nav-links-shop-btn"
        >
          <StorefrontIcon />
          <span>Shop</span>
        </button>

        <button
          type="button"
          aria-label="Open navigation menu"
          onClick={() => {
            setShopDrawerOpen(false);
            setDrawerOpen(true);
          }}
          className="mobile-nav-links-trigger mobile-nav-links-menu-btn"
        >
          <span>Menu</span>
          <MenuIcon />
        </button>
      </div>
      <MobileShopDrawer open={shopDrawerOpen} onClose={() => setShopDrawerOpen(false)} />
      <Drawer
        anchor="right"
        open={drawerOpen}
        PaperProps={{ className: "mobile-nav-links-drawer-paper" }}
        onClose={() => setDrawerOpen(false)}
      >
        <div className="mobile-nav-links-drawer-content">
          <div className="mobile-nav-links-contents">
            {navLinks.map((item) => (
              <div
                className="mobile-nav-links-link-container"
                onClick={() => setDrawerOpen(false)}
                key={item.href || item.label}
              >
                {item.useQuotePopup ? (
                  <div onClick={(e) => e.stopPropagation()}>
                    <QuoteRequestPopup
                      triggerLabel={item.label}
                      triggerVariant="link"
                      triggerClassName="mobile-nav-link"
                    />
                  </div>
                ) : item.usePaymentsPopup ? (
                  <div onClick={(e) => e.stopPropagation()}>
                    {/* <PaymentsButton variant="footer" /> */}
                  </div>
                ) : (
                  <Link
                    replace={item.label === "Careers"}
                    href={item.href || "#"}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default MobileNavLinks;
